import { render, staticRenderFns } from "./ManagerCommissionHistory.vue?vue&type=template&id=063e797e"
import script from "./ManagerCommissionHistory.vue?vue&type=script&lang=js"
export * from "./ManagerCommissionHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports